import React from "react";
import { useIntl } from "react-intl";

import { TableCellProps } from "../types";
import {
  imageCellClass,
  imageTitleCellClass,
  cellFigureClass,
  cellImageClass,
  cellImageCaptionClass,
} from "../TableQuestion.css";

export interface ImageCellProps
  extends Pick<
    TableCellProps,
    "cellId" | "image" | "alt" | "caption" | "colspan"
  > {
  isTitle?: boolean;
}

export const ImageCell: React.FC<ImageCellProps> = ({
  cellId,
  image,
  alt,
  caption,
  colspan,
  isTitle,
}) => {
  const intl = useIntl();

  const translatedAlt = alt
    ? intl.formatMessage({ id: alt, defaultMessage: alt })
    : "";

  const translatedCaption = caption
    ? intl.formatMessage({ id: caption, defaultMessage: caption })
    : "";

  return (
    <td
      key={cellId}
      className={isTitle ? imageTitleCellClass : imageCellClass}
      colSpan={colspan ? Number(colspan) : undefined}
    >
      {image && (
        <figure className={cellFigureClass}>
          <img src={image} alt={translatedAlt} className={cellImageClass} />
          {translatedCaption && (
            <figcaption className={cellImageCaptionClass}>
              {translatedCaption}
            </figcaption>
          )}
        </figure>
      )}
    </td>
  );
};
